<template>
  <FaIcon :icon="READER_DEFAULT_ICON" />
</template>

<script setup lang="ts">
import { READER_DEFAULT_ICON } from '@/constants/door';
</script>
